import { all, put, select, takeLatest } from 'redux-saga/effects';
import { getApiParams } from 'api';
import { encode } from 'js-base64';
import { getPath, getRegionDomain } from 'selectors/router';
import { pageModelFetchRequest, pageModelFetchSuccess, pageModelFetchFailed } from './slice';
import { ModelJson } from './types';
import { fetchPageModel } from './api';

export function* pageModelRootSaga() {
	return yield all([takeLatest(pageModelFetchRequest.type, () => getPageModel())]);
}

function formatModelJSON(model) {
	const breadcrumbs = [...model.breadcrumbs];
	breadcrumbs.pop();

	return { ...model, breadcrumbs };
}

export function* getPageModel() {
	try {
		const pathname: string = yield select(getPath);
		const region: string = yield select(getRegionDomain);

		const { url, config } = yield getApiParams('/sp/getModel');

		let modelJson: ModelJson = yield fetchPageModel(
			url,
			{
				pathname,
				region,
			},
			config
		);

		const formattedModel = yield formatModelJSON(modelJson); //	для форматирования хлебных крошек

		// Для хардкода типовых
		if (formattedModel?.rules?.rulesText) {
			formattedModel.rules.rulesText = encode(formattedModel.rules.rulesText);
		}

		// Для хардкода дополнительных текстов на SLP
		if (formattedModel?.service?.categoryText) {
			formattedModel.service.categoryText = encode(formattedModel.service.categoryText);
		}

		yield put(pageModelFetchSuccess({ data: formattedModel }));
	} catch (error) {
		yield put(
			pageModelFetchFailed({ error: { code: error?.status || 500, message: error?.message } })
		);
	}
}
